import { render, staticRenderFns } from "./DisableInteraction.vue?vue&type=template&id=15c816bc&scoped=true&"
import script from "./DisableInteraction.vue?vue&type=script&lang=js&"
export * from "./DisableInteraction.vue?vue&type=script&lang=js&"
import style0 from "./DisableInteraction.vue?vue&type=style&index=0&id=15c816bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c816bc",
  null
  
)

export default component.exports